/**
 * Service per caricare TUTTE le presenze di uno studente
 * da tutti i corsi (corrente + precedenti) con informazioni
 * complete su recuperi, sessioni e corsi.
 *
 * Questo servizio sostituisce la vecchia logica frammentata
 * che caricava presenze corso per corso.
 */

import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var qs = require("querystring");

export default async function getPresenzeStudente(uname, token, studenteId) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getPresenzeStudente.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        try {
          const bodyString = body.toString();
          console.log(
            "[getPresenzeStudente] Raw response (first 500 chars):",
            bodyString.substring(0, 500)
          );

          const resp = JSON.parse(bodyString);

          if (resp.result === "error") {
            console.error(
              "[getPresenzeStudente] Errore dal backend:",
              resp.message
            );
            reject(new Error(resp.message));
            return;
          }

          console.log(
            `[getPresenzeStudente] ✓ Caricate ${resp.total} presenze per studente ${studenteId}`
          );
          console.log(
            "[getPresenzeStudente] Sample (prime 3):",
            resp.presenze?.slice(0, 3)
          );

          // Ritorna l'array di presenze (per compatibilità con vecchio codice)
          resolve(resp.presenze || resp);
        } catch (error) {
          console.error(
            "[getPresenzeStudente] Errore nel parsing JSON:",
            error
          );
          console.error(
            "[getPresenzeStudente] Response body:",
            body.toString()
          );
          reject(
            new Error(`Errore nel parsing della risposta: ${error.message}`)
          );
        }
      });

      res.on("error", function(error) {
        console.error("[getPresenzeStudente] Errore HTTP:", error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      idStudente: studenteId, // Nuovo nome parametro
      studentId: studenteId, // Backward compatibility
    });

    req.write(postData);

    req.end();
  });
}
